<template>
  <div class="fast-provider">
    <div class="fast-provider-avatar flex items-center justify-center">
      <CUserAvatar :user-avatar-url="currentUrl" :user-avatar-name="name[0]" :user-avatar-color="avatarColor" :size="50" />
      <transition>
        <img v-show="transitioning" :src="oldUrl" class="fast-provider-fading-avatar" />
      </transition>
    </div>
    <div class="fast-provider-activity" :class="{ bounce: transitioning, inactive: !logged }"></div>
  </div>
</template>

<script>
import CUserAvatar from '@/apps/shared/components/UserAvatar.vue'
export default {
  components: {
    CUserAvatar
  },
  props: {
    url: {
      type: String,
      default: null
    },
    logged: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      default: 'C'
    },
    avatarColor: {
      type: String,
      default: '#555'
    }
  },
  data() {
    return {
      currentUrl: this.url,
      oldUrl: null,
      transitioning: false
    }
  },
  methods: {
    changeTo(newUrl) {
      this.oldUrl = this.currentUrl
      this.currentUrl = newUrl
      this.transitioning = true
      setTimeout(() => {
        this.transitioning = false
      }, 1500)
    }
  }
}
</script>

<style lang="scss" scoped>
$avatar-size: 50px;
$activity-size: round($avatar-size * 0.31);
.fast-provider {
  position: relative;
  z-index: -1;
  .fast-provider-avatar {
    border-radius: 50%;
    height: $avatar-size;
    width: $avatar-size;
    overflow: hidden;
    border: 4px solid white;
    background: #777;
    position: relative;
    img {
      width: 100%;
      height: 100%;
      border-radius: 50%;
    }
    img.fast-provider-fading-avatar {
      position: absolute;
      top: 0;
      left: 0;
      opacity: 0;
      &.v-enter-active {
        transition: opacity 1.5s ease-in-out;
        &.v-enter {
          opacity: 1;
        }
        &.v-enter-to {
          opacity: 0;
        }
      }
      &.v-leave-active {
        transition: none;
        opacity: 0;
      }
    }
  }
  .fast-provider-activity {
    border-radius: 50%;
    height: $activity-size;
    width: $activity-size;
    overflow: hidden;
    border: 3px solid white;
    background: #00d045;
    position: absolute;
    right: 0px;
    top: $avatar-size - $activity-size - 2px;
    &.bounce {
      animation: bounce 1s ease 0.2s;
    }
    &.inactive {
      transform: scale(0);
    }
    @keyframes bounce {
      0% {
        transform: scale(1);
      }
      50% {
        transform: scale(0);
      }
      90% {
        transform: scale(1.333);
      }
      100% {
        transform: scale(1);
      }
    }
  }
}
</style>
